// R2 객체 키 -> 표시 URL.
// API Worker 의 GET /images/:kind/:date/:filename 라우트를 경유한다.
// 관리자 콘솔 측에 동일한 헬퍼가 있지만 의존성 분리 원칙으로 별도 작성한다.

const API_BASE = import.meta.env.VITE_API_BASE;

// R2 이미지 키를 공개 절대 URL 로 변환. 키가 없으면 null.
export function imageUrl(key: string | null | undefined): string | null {
  if (!key) {
    return null;
  }
  return `${API_BASE}/images/${key}`;
}
